import { render, staticRenderFns } from "./GatePendingVisitors.vue?vue&type=template&id=0a2c004a&"
import script from "./GatePendingVisitors.vue?vue&type=script&lang=js&"
export * from "./GatePendingVisitors.vue?vue&type=script&lang=js&"
import style0 from "./GatePendingVisitors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports